import styled from '@emotion/styled';
import Link from 'next/link';

const StyledA = styled(Link)(
  {
    marginLeft: '5px',
    textDecoration: 'underline',
    cursor: 'pointer'
  },
  ({ theme }) => ({
    color: theme.palette.colors.gold
  })
);

export default StyledA;
